import React from 'react';

const TikTokIcon = ({ className = "h-6 w-6", color = "currentColor" }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.6 5.82c.9 1.04 2.19 1.72 3.4 1.72v-2.5c-.24 0-.48-.03-.71-.08v1.88c-1.21 0-2.5-.68-3.4-1.72v7.89c0 4.1-3.32 7.42-7.42 7.42-1.54 0-2.97-.47-4.16-1.27 1.35 1.38 3.23 2.23 5.31 2.23 4.1 0 7.42-3.32 7.42-7.42V5.82Z"
        fill={color}
      />
      <path
        d="M17.29 4.23c-.74-.93-1.19-2.1-1.19-3.38h-1.9v15.17c0 2.19-1.77 3.96-3.96 3.96-1.09 0-2.08-.44-2.79-1.15.85.97 2.11 1.58 3.52 1.58 2.19 0 3.96-1.77 3.96-3.96V4.23ZM8.9 12.12c-2.19 0-3.96 1.77-3.96 3.96 0 1.69 1.06 3.13 2.55 3.69-.56-.61-.9-1.42-.9-2.31 0-1.9 1.54-3.44 3.44-3.44.38 0 .75.06 1.09.18v-2.05c-.35-.07-.72-.1-1.09-.1-.13 0-.25 0-.37.01v1.44c-.34-.12-.71-.18-1.09-.18Z"
        fill={color}
      />
      <path
        d="M19.29 5.04v-.7c-.61 0-1.21-.13-1.77-.37.67.42 1.34.8 1.77 1.07ZM17.52 3.97c-.08-.1-.15-.2-.23-.31v.31h.23ZM8.53 15.97c-.38 0-.75.06-1.09.18v1.51c.34-.12.71-.18 1.09-.18 1.9 0 3.44 1.54 3.44 3.44 0 .89-.34 1.7-.9 2.31 1.49-.56 2.55-2 2.55-3.69 0-2.19-1.77-3.96-3.96-3.96h-.13Z"
        fill={color}
      />
    </svg>
  );
};

export default TikTokIcon;